module.exports = __webpack_public_path__ + "static/img/04.6f26965.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/04.png
// module id = pVxq
// module chunks = 0